import { Button, makeStyles, mergeClasses, shorthands } from '@fluentui/react-components';
import { Dismiss20Regular } from '@fluentui/react-icons';
import { PropsWithChildren } from 'react';
import { customPalette } from '../../theme';

export interface IFilterGroupProps {
    isFiltered: boolean;
    clearAllFiltersLabel: string;
    clearAllFilters: () => void;
    containerClassname?: string;
    dataTestid?: string;
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '15px',
    },
    buttonStyle: {
        backgroundColor: '#fff',
        ...shorthands.border('1px', 'solid', customPalette.neutralLightGrey),
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.06), 0px 5px 4px -4px rgba(0, 0, 0, 0.02)',

        order: 1,
        marginLeft: '10px',
    },
    cancelButtonIcon: {
        height: '12px',
        width: '12px',
        order: 1,
    },
});

const FilterGroup: React.FC<PropsWithChildren<IFilterGroupProps>> = ({
    children,
    isFiltered,
    containerClassname,
    clearAllFiltersLabel,
    clearAllFilters,
    dataTestid,
}) => {
    const styles = useStyles();

    return (
        <div data-testid={dataTestid} className={mergeClasses(styles.root, containerClassname)}>
            {children}
            {isFiltered && (
                <Button
                    appearance='secondary'
                    className={styles.buttonStyle}
                    icon={<Dismiss20Regular className={styles.cancelButtonIcon} />}
                    aria-label={clearAllFiltersLabel}
                    onClick={clearAllFilters}
                >
                    {clearAllFiltersLabel}
                </Button>
            )}
        </div>
    );
};

export default FilterGroup;
